import { fromJS, List, Record } from 'immutable';
import _ from 'lodash';

const properties = {
  id: '',
  resource: '',
  categories: List(),
};

export default class Picture extends Record(properties, 'Picture') {
  public readonly id!: string;

  public readonly resource!: string;

  public readonly categories!: List<string>;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      categories: fromJS(values.categories || []),
    });
  }
}
